export default {
  name: 'PrintVersion'
}
